var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m14.5 5.2c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-1.9-4.3-4.3-4.3z",
  fill: "#505050"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m14.5 15.5c-3 0-5.5 2.5-5.5 5.5v2.5h-5c-0.8 0-1.4 0.6-1.4 1.4s0.6 1.4 1.4 1.4h5v3.2h2v10.5c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5v-9.5h1v9.5c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5v-19c0-3-2.5-5.5-5.5-5.5z",
  fill: "#505050"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 18.7,
  width: 3,
  height: 4.2,
  rx: 0.6,
  fill: "#fc0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m32 9.2c-2.1 0-3.9 1.7-3.9 3.9s1.7 3.9 3.9 3.9 3.9-1.7 3.9-3.9-1.8-3.9-3.9-3.9z",
  fill: "#c9c9c9"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m32 6.8c-2.4 0-4.4 1.8-4.6 4.2h9.2c-0.2-2.4-2.2-4.2-4.6-4.2z",
  fill: "#fc0"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 26.2,
  y: 10.6,
  width: 11.6,
  height: 1.7,
  rx: 0.85,
  fill: "#fc0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m32 18c-2.8 0-5 2.2-5 5v7.5h1.9v9c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5v-8h0.6v8c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5v-9h1.5v-7.5c0-2.8-2.2-5-5-5z",
  fill: "#fc0"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 27,
  y: 23.4,
  width: 10,
  height: 1.9,
  fill: "#c9c9c9"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m38.4 29.6v-1c0-1 0.8-1.8 1.8-1.8s1.8 0.8 1.8 1.8v1h1.2c0.6 0 1 0.4 1 1v4.2c0 0.6-0.4 1-1 1h-6c-0.6 0-1-0.4-1-1v-4.2c0-0.6 0.4-1 1-1zm1.2 0h1.2v-1c0-0.3-0.3-0.6-0.6-0.6s-0.6 0.3-0.6 0.6z",
  fill: "#505050"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 38.9,
  y: 31.4,
  width: 2.6,
  height: 1.6,
  rx: 0.4,
  fill: "#c9c9c9"
});

function SvgVendorEscort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorEscort);
export default __webpack_public_path__ + "static/media/vendor-escort.dab3fc8345ab57cd2f5ed27ded478da8.svg";
export { ForwardRef as ReactComponent };